import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '100%',
    },
    requiremmentList: {
      marginTop: 15,
    },
    mt: {
      marginTop: 15,
    },
    mtLg: {
      marginTop: 35,
    },
    label: {
      fontSize: 11,
      marginLeft: 6,
      color: theme.palette.primary.main,
    },
    radiosDescription: {
      marginLeft: 30,
      color: theme.palette.secondary.light,
      fontSize: 12,
      marginBottom: 12,
    },
    radiosLabel: {
      '& .MuiFormControlLabel-label': {
        fontWeight: 600,
        fontSize: 13,
        color: theme.palette.secondary.dark,
      },
    },
    radiosContainer: {
      marginTop: '15px',
      paddingLeft: '12px',
    },
    formContainer: {
      margin: '0 auto ',
      width: '100%',
    },
    groupForm: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    rowContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      marginTop: '18px',
    },
    radioRow: {
      textAlign: 'right',
    },
    endWeek: {
      textAlign: 'right',
      '& span': {
        fontSize: 14,
      },
    },
    timePicker: {
      marginBottom: 8,
      marginTop: 16,
      '& label': {
        fontSize: '14px !important',
      },
      paddingTop: 17,
    },
    helpIcon: {
      fontSize: 16,
      marginLeft: 5,
    },
    tableError: {
      color: theme.palette.error.main,
    },
  };
});

export default useStyles;
